import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 */
/**
 * Helper: for non-it languages, English slugs are used as international default.
 */
const intl = (it: string, en: string) =>
  ({ it, en, fr: en, de: en, es: en, pt: en, pl: en }) as const

export const localizedRoutes = {
  home: intl('', ''),
  chiSiamo: intl('chi-siamo', 'about'),
  aboutJourney: intl('fg-il-percorso', 'about/our-journey'),
  certifications: intl('certificazioni', 'about/certifications'),
  partnerships: intl('partnership', 'about/partnerships'),
  sectors: intl('settori', 'sectors'),
  industrialAutomation: intl('settori#automazione', 'sectors#industrial-automation'),
  aiVision: intl('settori#intelligenza-artificiale', 'sectors#ai-vision-systems'),
  industrialDistribution: intl('settori#distribuzione', 'sectors#industrial-distribution'),
  tertiarySector: intl('settori#terziario', 'sectors#tertiary-sector'),
  renewableEnergy: intl('settori#rinnovabili', 'sectors#renewable-energy'),
  processes: intl('processi', 'processes'),
  design: intl('progettazione', 'processes/design'),
  manufacturing: intl('realizzazione', 'processes/manufacturing'),
  finalStage: intl('finale', 'processes/final-stage'),
  news: intl('news', 'news'),
  contact: intl('contatti', 'contact'),
  careers: intl('lavora-con-noi', 'careers'),
  privacy: intl('privacy', 'privacy'),
  cookies: intl('cookie-policy', 'cookie-policy'),
  legalNotes: intl('note-legali', 'legal-notes'),
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment (or full path without lang prefix)
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
